import api from '../REST/api';
import { markUiAction } from '../utils/create-ui-action';

// eslint-disable-next-line import/prefer-default-export
export const fetchMerchants = () => (dispatch, getState) => {
  const { merchants } = getState();
  if (merchants.length) {
    return Promise.resolve({ value: merchants });
  }
  return dispatch(
    markUiAction({
      type: fetchMerchants.toString(),
      payload: api.getZMSAMMerchants(),
    }),
  );
};

fetchMerchants.toString = () => 'merchants/fetch';
